import currency from "currency.js";

export const volumeFormatter = (volume: number) => currency(volume, { precision: 0, symbol: "" }).format();
